/**
 * Constantes compartidas de la aplicación
 */

// Tipos de pago/hitos
export const PAYMENT_TYPES = {
  UNICO: 'UNICO',
  DOS_PAGOS: 'DOS_PAGOS',
  TRES_PAGOS: 'TRES_PAGOS',
  CUATRO_PAGOS: 'CUATRO_PAGOS',
};

export const PAYMENT_TYPE_OPTIONS = [
  { value: 'UNICO', label: 'Hito Único' },
  { value: 'DOS_PAGOS', label: '2 Hitos' },
  { value: 'TRES_PAGOS', label: '3 Hitos' },
  { value: 'CUATRO_PAGOS', label: '4 Hitos' },
];

// Estados de facturación
export const BILLING_STATUS = {
  PTE_FACTURAR: 'Pte facturar',
  FACTURADO: 'Facturado',
};

export const BILLING_STATUS_OPTIONS = [
  { value: 'Pte facturar', label: 'Pte facturar' },
  { value: 'Facturado', label: 'Facturado' },
];

// Idiomas disponibles
export const LANGUAGES = ['Español', 'Inglés', 'Francés'];

// Campos de búsqueda por destino para el Dashboard
export const SEARCH_FIELDS_BY_DESTINATION = {
  ANMAR: [
    { value: 'num_ensayo', label: 'Nº GOYA' },
    { value: 'num_anmar', label: 'Nº ANMAR' },
    { value: 'client', label: 'Cliente' },
    { value: 'ensayo', label: 'Ensayo' },
    { value: 'product', label: 'Producto' },
    { value: 'status_id', label: 'Estado' },
    { value: 'fecha_entrada', label: 'F. Entrada' },
    { value: 'fecha_ejecucion', label: 'F. Ejecución' },
    { value: 'fecha_envio', label: 'F. Envío' },
    { value: 'fecha_informe', label: 'F. Informe' },
  ],
  GAIKER: [
    { value: 'num_ensayo', label: 'Nº GOYA' },
    { value: 'num_presupuesto_goya', label: 'Nº Presupuesto GOYA' },
    { value: 'num_presupuesto_gaiker', label: 'Nº Presupuesto GAIKER' },
    { value: 'client', label: 'Cliente' },
    { value: 'ensayo', label: 'Ensayo' },
    { value: 'product', label: 'Producto' },
    { value: 'status_id', label: 'Estado' },
    { value: 'fecha_entrada', label: 'F. Entrada' },
    { value: 'fecha_envio', label: 'F. Envío' },
  ],
  IVAMI: [
    { value: 'num_ensayo', label: 'Nº GOYA' },
    { value: 'num_proforma_ivami', label: 'Nº Proforma IVAMI' },
    { value: 'client', label: 'Cliente' },
    { value: 'ensayo', label: 'Ensayo IVAMI' },
    { value: 'product', label: 'Producto' },
    { value: 'status_id', label: 'Estado' },
    { value: 'fecha_entrada', label: 'F. Entrada' },
    { value: 'fecha_envio', label: 'F. Envío' },
    { value: 'fecha_envio_informe', label: 'F. Envío Informe' },
  ],
  REGULATORY: [
    { value: 'num_ensayo', label: 'Nº GOYA' },
    { value: 'num_presupuesto_goya', label: 'Nº Presupuesto GOYA' },
    { value: 'client', label: 'Cliente' },
    { value: 'product', label: 'Producto' },
    { value: 'status_id', label: 'Estado' },
    { value: 'fecha_entrada', label: 'F. Entrada' },
    { value: 'fecha_envio', label: 'F. Envío' },
  ],
  ESTABILIDADES: [
    { value: 'num_ensayo', label: 'Nº GOYA' },
    { value: 'client', label: 'Cliente' },
    { value: 'product', label: 'Producto' },
    { value: 'status_id', label: 'Estado' },
    { value: 'fecha_entrada', label: 'F. Entrada' },
  ],
};

// Columnas para la página de Informes
export const INFORMES_COLUMNS_BY_DESTINATION = {
  ANMAR: [
    { key: 'client', label: 'Cliente' },
    { key: 'product', label: 'Producto' },
    { key: 'num_ensayo', label: 'Nº Goya' },
    { key: 'num_challenge', label: 'Nº Challenge' },
    { key: 'num_anmar', label: 'Nº Anmar' },
    { key: 'fecha_entrada', label: 'F. Entrada Goya', isDate: true },
    { key: 'fecha_envio', label: 'F. Envío', isDate: true },
    { key: 'resultado_otros_ensayos', label: 'Resultado Otros Ensayos', isEditable: true },
  ],
  GAIKER: [
    { key: 'client', label: 'Cliente' },
    { key: 'product', label: 'Producto' },
    { key: 'num_ensayo', label: 'Nº Goya' },
    { key: 'num_presupuesto_goya', label: 'Nº Presupuesto Goya' },
    { key: 'num_presupuesto_gaiker', label: 'Nº Presupuesto Gaiker' },
  ],
  IVAMI: [
    { key: 'client', label: 'Cliente' },
    { key: 'product', label: 'Producto' },
    { key: 'num_ensayo', label: 'Nº Goya' },
    { key: 'num_proforma_ivami', label: 'Nº Proforma Ivami' },
    { key: 'fecha_entrada', label: 'F. Entrada Goya', isDate: true },
    { key: 'fecha_envio', label: 'F. Envío', isDate: true },
  ],
  REGULATORY: [
    { key: 'client', label: 'Cliente' },
    { key: 'product', label: 'Producto' },
    { key: 'num_ensayo', label: 'Nº Goya' },
    { key: 'num_presupuesto_goya', label: 'Nº Presupuesto Goya' },
    { key: 'fecha_entrada', label: 'F. Entrada Goya', isDate: true },
  ],
  ESTABILIDADES: [
    { key: 'client', label: 'Cliente' },
    { key: 'product', label: 'Producto' },
    { key: 'num_ensayo', label: 'Nº Goya' },
    { key: 'fecha_entrada', label: 'F. Entrada Goya', isDate: true },
  ],
};

// Meses del año
export const MONTHS = [
  { value: '01', label: 'Enero' },
  { value: '02', label: 'Febrero' },
  { value: '03', label: 'Marzo' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Mayo' },
  { value: '06', label: 'Junio' },
  { value: '07', label: 'Julio' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' },
];

// Meses con nombre completo para selects
export const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

// Paginación por defecto
export const DEFAULT_PAGE_SIZE = {
  DASHBOARD: 10,
  INFORMES: 20,
  CLIENTES: 15,
};
